import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { selectProfileForFocussedEvent } from "../redux/selectors";
import {} from "../redux/actions";
import { Avatar, TextField, Typography } from "@material-ui/core";
const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    },
    avatar: {
        margin: 10,
        padding: 10,
        backgroundColor: "rgb(63,81,181)"
    },
    bigAvatar: {
        width: "130px",
        height: "130px",
        display: "block",
        margin: "0 auto"
    },
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit
    },
    dense: {
        marginTop: 16
    },
    menu: {
        width: 200
    }
});
class EmployeesDetail extends React.Component {
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    state = {
        name: "Cat in the Hat",
        age: "",
        multiline: "Controlled",
        currency: "EUR"
    };

    render() {
        const { classes, profile } = this.props;

        return (
            <div className="EmployeesDetail">
                <div className="EmployeesDetail-avatar">
                    <Typography
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 1,
                            gridColumnStart: 1,
                            gridColumnEnd: 3
                        }}
                    >
                        Employee Profile
                    </Typography>
                    <Avatar
                        alt="profile avatar"
                        className={classes.bigAvatar}
                        src={profile["profile_image_url"]}
                        style={{
                            gridColumnStart: 1,
                            gridColumnEnd: 3,
                            gridRowStart: 2,
                            gridRowEnd: 3,
                            alignSelf: "center",
                            justifySelf: "center"
                        }}
                    />
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 4,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="First name"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["first_name"]}
                            style={{
                                width: "100%"
                            }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 4,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="Last name"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["last_name"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
                <div className="EmployeesDetail-qualifications">
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 2,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="Job Title"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["job_title"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 2,
                            gridRowEnd: 3,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="Email"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["email"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 4,
                            gridColumnStart: 1,
                            gridColumnEnd: 1
                        }}
                    >
                        <TextField
                            label="Account Created"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["account_created"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 1,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="Last Active"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["last_active"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 2,
                            gridRowEnd: 2,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="Agreed To EULA"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["agreed_to_eula"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 3,
                            gridColumnStart: 2,
                            gridColumnEnd: 2
                        }}
                    >
                        <TextField
                            label="EULA Timestamp"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["agreed_to_eula_timestamp"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: 1,
                            gridColumnStart: 3,
                            gridColumnEnd: 3
                        }}
                    >
                        <TextField
                            label="Years in Position"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["years_in_present_position"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 2,
                            gridRowEnd: 2,
                            gridColumnStart: 3,
                            gridColumnEnd: 3
                        }}
                    >
                        <TextField
                            label="Contract Type"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={profile["direct_or_subcontractor"]}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        className={"EmployeeDetailText"}
                        style={{
                            gridRowStart: 3,
                            gridRowEnd: 3,
                            gridColumnStart: 3,
                            gridColumnEnd: 3
                        }}
                    >
                        <TextField
                            label="Years of Experience"
                            margin="normal"
                            variant="filled"
                            InputProps={{
                                readOnly: true
                            }}
                            value={
                                profile[
                                    "level_of_experience_in_simular_industry"
                                ]
                            }
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(
    connect(
        store => {
            return { profile: selectProfileForFocussedEvent(store) };
        },
        {}
    )(EmployeesDetail)
);
